var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6795_1455",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6795_1455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.93568 24.0001L1.40234 16.4668L3.30234 14.6001L10.8357 22.1335L8.93568 24.0001ZM16.469 24.0001L8.93568 16.4668L10.8023 14.5668L16.469 20.2335L28.7357 7.9668L30.6023 9.8668L16.469 24.0001ZM16.469 16.4668L14.569 14.6001L21.169 8.00013L23.069 9.8668L16.469 16.4668Z",
    fill: "#15B525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAll);
export default __webpack_public_path__ + "static/media/done_all.60c8d9ed7db35eff749e00c6d1e34e17.svg";
export { ForwardRef as ReactComponent };